import { FlowType } from '@cash-web/protos/squareup/cash/plasma/flows/FlowProto.pb'
import { GetFlowResponse } from '@cash-web/protos/squareup/franklin/app/flow.pb'
import { getFlow } from '@cash-web/shared-data-access-api/api'
import { ensureQueryData } from '@cash-web/shared-data-access-api/ensureQueryData'
import { useQueryGetGraphicsPackage } from '@cash-web/shared-data-access-api/react-query/useQueryGetGraphicsPackage'
import { LoaderFunctionArgsWithContext } from '@cash-web/shared-journey-util-main'
import { prefetchCardAssets } from '@cash-web/shared-ui-card-assets/prefetchCardAssets'

type FlowDataLoader = (args: LoaderFunctionArgsWithContext) => Promise<void> | void

async function load3dGridFlow({ context }: LoaderFunctionArgsWithContext) {
  void prefetchCardAssets()
  if (context?.featureFlags['cash-web-server-driven-3d'] !== true) return
  await ensureQueryData(context.queryClient, useQueryGetGraphicsPackage.asQueryConfig({}))
}

const flowDataLoaders: Partial<Record<FlowType, FlowDataLoader>> = {
  [FlowType.CHANGE_CARD_DESIGN]: () => {
    void prefetchCardAssets()
  },
  [FlowType.REQUEST_PHYSICAL_CARD]: load3dGridFlow,
  [FlowType.ORDER_PAYMENT_DEVICE]: load3dGridFlow,
}

export async function getFlowInitiationDataLoader(args: LoaderFunctionArgsWithContext): Promise<GetFlowResponse> {
  const { request, params } = args
  const flowType = params['initiationData'] as FlowType

  const url = new URL(request.url)
  const paramsFromSearch = url.searchParams.get('params')
  const type = url.searchParams.get('params_type')

  const initiationDataWithSearch = `${flowType}${url.search}`

  const initiationData = paramsFromSearch
    ? type
      ? `${flowType}?params_type=${type}&params=${paramsFromSearch}`
      : `${flowType}?params=${paramsFromSearch}`
    : initiationDataWithSearch

  const [response] = await Promise.all([
    getFlow({ initiation_data: initiationData }),
    flowDataLoaders[flowType]?.(args),
  ])

  return response
}

export async function getFlowTypeLoader(args: LoaderFunctionArgsWithContext): Promise<GetFlowResponse> {
  const { request, params } = args
  const flowType = params['flowType'] as FlowType
  const url = new URL(request.url)
  const flowTypeWithSearch = `${flowType}${url.search}`

  const [response] = await Promise.all([
    getFlow({ initiation_data: flowTypeWithSearch }),
    flowDataLoaders[flowType]?.(args),
  ])

  return response
}
